import 'selectize';

$('select')
  .not('.js-no-selectize, .js-card-select')
  .selectize();

$('select.js-card-select').selectize({
  render: {
    item: selectCardTemplate,
    option: selectCardTemplate,
  },
});

function selectCardTemplate(data, escape) {
  const brand = data.value == 'new' ? '' : `<i class="card-brand ${data.brand}"></i>`;
  return `<div>${brand} ${escape(data.text)}</div>`;
}



// WEBPACK FOOTER //
// app/javascript/common/custom-selects.js